export const TUTORIAL_COMPLETION_KEY = 'graftcode-tutorial-completion'

export const TUTORIAL_COMPLETION_EVENT = 'graftcode-tutorial-completion-changed'

export const ACADEMY_VISITED_KEY = 'graftcode-academy-visited'

export const PORTAL_ONBOARDING_STATUS_KEY = 'graftcode-portal-onboarding-status'

/** @deprecated Read via getPortalOnboardingStatus migration only */
export const LEGACY_PORTAL_ONBOARDING_STATUS_KEY = 'graftcode-portal-tutorial-status'

export const PORTAL_ONBOARDING_STATUS_EVENT = 'graftcode-portal-onboarding-status-changed'

export const DASHBOARD_ONBOARDING_DISMISSED_KEY = 'graftcode-dashboard-onboarding-dismissed'

export const DASHBOARD_ONBOARDING_DISMISSED_EVENT = 'graftcode-dashboard-onboarding-dismissed-changed'

export const DASHBOARD_ONBOARDING_PROGRESS_KEY = 'graftcode-dashboard-onboarding-progress'

export const DASHBOARD_ONBOARDING_PROGRESS_EVENT = 'graftcode-dashboard-onboarding-progress-changed'
